import { Input as InputNextUI, InputProps } from '@nextui-org/react';
import { cn } from '@nextui-org/theme';
import React from 'react';

import { Asterisk, Eye, EyeSlash } from '@phosphor-icons/react';

const Input: React.FC<InputProps> = ({ label, required, type = 'text', ...props }) => {
  const [isVisible, setIsVisible] = React.useState<boolean>(false);

  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <div className='w-full'>
      {label && (
        <div className='mb-[6px] flex gap-1'>
          <div className='text-primary font-medium text-sm'>{label}</div>
          {required && <Asterisk size={10} color='#D92D20' weight='bold' className='mt-[2px]' />}
        </div>
      )}
      <InputNextUI
        size='lg'
        radius='sm'
        variant='bordered'
        type={type === 'password' ? (isVisible ? 'text' : 'password') : type}
        endContent={
          type === 'password' && (
            <button
              className='focus:outline-none'
              type='button'
              onClick={toggleVisibility}
              aria-label='toggle password visibility'
            >
              {isVisible ? (
                <Eye color='#667085' size={20} />
              ) : (
                <EyeSlash color='#667085' size={20} />
              )}
            </button>
          )
        }
        classNames={{
          inputWrapper: cn(
            'bg-white shadow-none border-1 border-borderPrimary',
            'hover:border-border-brand group-data-[focus=true]:border-border-brand',
          ),
          input: 'placeholder:text-text-placeholder',
          errorMessage: 'text-text-error-primary',
        }}
        {...props}
      />
    </div>
  );
};

export default Input;
